function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M107.042 8.70711C107.433 8.31658 107.433 7.68342 107.042 7.29289L100.679 0.928932C100.288 0.538408 99.6548 0.538408 99.2643 0.928932C98.8738 1.31946 98.8738 1.95262 99.2643 2.34315L104.921 8L99.2643 13.6569C98.8738 14.0474 98.8738 14.6805 99.2643 15.0711C99.6548 15.4616 100.288 15.4616 100.679 15.0711L107.042 8.70711ZM0 9H106.335V7H0V9Z",
  fill: "#484848"
});

var SvgIcoArrow = function SvgIcoArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 16,
    viewBox: "0 0 108 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_arrow.2b29d2e6.svg";
export { ForwardRef as ReactComponent };